<div class="fpx-form-control" [ngClass]="{'after-upload': this.uploadStatus == 'Success'}">
  <fpx-label [label]="label" [control]="formControl"></fpx-label>
  <div class="file-input-contents">
    <div class="fpx-field-content fpx-file-input">
      <div class="file-field">
        <img class="document" src="./assets/images/sbc/files.svg" alt="Upload" />
        <span (click)="previewFile()"
          [ngClass]="{
            'upload-initial': uploadStatus === '',
            'upload-success': uploadStatus === 'Success',
            'upload-failure': uploadStatus === 'Failure'
          }"
          >{{ (this.files?.length > 1? 'Files (+'+this.files?.length+')': this.files?.[0]?.name) || this.uploadTitle }}</span
        >
      </div>
      <div class="file-icon" [attr.disabled]="files?.length == this.maxFilesCount">
        <ng-container>
          <!-- <div class="icon" (click)="fileInput.click()">
            <img src="./assets/images/enter_details.svg" alt="Browse" />
          </div> -->
          <label class="custom-file-upload icon">
            <input #fileInput type="file" [disabled]="isReadonly" [accept]="acceptFormat" (click)="onFileClick($event)" (change)="onFileSelected($event)" style="display: none" />
            <img src="./assets/images/sbc/attachement.svg" alt="Upload" />
            <span class="label" *ngIf="label">{{ this.uploadTitle }}</span>
          </label>
          <div class="icon delete" (click)="onDelete()" *ngIf="!isReadonly">
            <img src="./assets/images/icons/delete.svg" alt="Delete" />
          </div>
        </ng-container>
  
        <!-- <ng-container *ngIf="previewDeleteVisible">
          <div class="icon" (click)="previewFile()">
            <img src="./assets/images/icons/download.svg" alt="Preview" />
          </div>
          <div class="icon" (click)="onDelete()">
            <img src="./assets/images/icons/delete.svg" alt="Delete" />
          </div>
        </ng-container> -->
      </div>
    </div>
    <div class="fpx-field-content fpx-file-input camera" *ngIf="!isReadonly && _commonService.getApplicationMode() != 'RM' && documentType == 'SELFIE'">
      <div class="file-icon" >
        <box class="custom-file-upload-icon">
          <ng-container *ngIf="_commonService.isMobile(); else webcam">
            <label class="custom-file-upload icon">
              <input type="file" accept="image/*" capture="user" (change)="onFileSelected($event)" style="display: none;" />
              <img src="./assets/images/sbc/camera.svg" alt="Take A Photo" />
            </label>
          </ng-container>
          <ng-template #webcam>
            <button btnType="button" (click)="takeAPhotos()">
              <img src="./assets/images/sbc/camera.svg" alt="camera" />
              <span class="label" *ngIf="label">Take A Photo</span>
            </button>
          </ng-template>
        </box>
      </div>
    </div>
  </div>
  
  <mat-error *ngIf="(formControl && formControl.invalid && formControl.touched) || showError">
    {{ errorCode }}
  </mat-error>
</div>
